import { IOfferForMobileSiteSchema } from 'shared/repositories/search-engine/entities/offer/OfferForMobileSiteSchema';

export const prepareOfferUrl = (offer: IOfferForMobileSiteSchema): string => {
  const { isCianPartner, externalOfferUrl } = offer;

  if (isCianPartner && externalOfferUrl) {
    return externalOfferUrl;
  }

  return `/${offer.dealType}/${offer.offerType}/${offer.id}`;
};
